export const REGION: string = import.meta.env.VITE_APP_REGION as string;
export const USER_POOL_ID: string = import.meta.env
  .VITE_APP_USER_POOL_ID as string;
export const USER_POOL_CLIENT_ID: string = import.meta.env
  .VITE_APP_USER_POOL_CLIENT_ID as string;
export const LANDING_PAGE_URL: string = import.meta.env
  .VITE_APP_LANDING_PAGE_URL as string;
export const ENVIRONMENT_LABEL: string = import.meta.env
  .VITE_APP_ENVIRONMENT_LABEL as string;
export const SENTRY_DSN: string = import.meta.env.VITE_APP_SENTRY_DSN as string;
export const SENTRY_PROPAGATION_TARGET: string = import.meta.env
  .VITE_APP_SENTRY_PROPAGATION_TARGET as string;